import { pxChangeVw } from "@/utils";
import { is_tr_link } from "@/i18n/lang";
import Svg07 from "@assets/icons/svg07.svg?react";
import { speakText } from "@/utils/speakText";
export default function HourLayout({ index, _hour, ariaLabel, item, temperatureText }: any) {
  return (
    <div
      className="flex flex-col justify-start items-center text-center p-[10px_5px] align-top"
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={() => speakText(ariaLabel)}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          speakText(ariaLabel);
        }
      }}
    >
      <div className="flex-[1]">
        <h3>{temperatureText}</h3>
      </div>
      <div className="h-30 flex-[1]">
        <WeatherImage className="h-30 block" src={item?.WeatherIconImg} />
      </div>
      <div className="flex-[1]">
        {item?.Wind?.Value} {item?.Wind?.Unit}
      </div>
      <div className="text-12 center gap-x-2 flex-[1]">
        <Svg07 style={{ width: pxChangeVw("8px") }} />
        <span>{is_tr_link() ? "%" + item?.PrecipitationProbability : item?.PrecipitationProbability + "%"}</span>
      </div>
      <div className="text-12 flex-[1]" style={{ color: index === 0 ? "var(--app-text-04)" : "var(--app-text-02)" }}>
        {_hour}
      </div>
    </div>
  );
}
